<template>
  <div class="container">
    <div
      class="trigger"
      :style="{fontFamily: `'${fontFamily.value.split('/').pop()}'`}"
      @click="openPopup();$analysis('material_setting_panel_base,click_fontList,设置面板_一级_字体菜单')"
    >
      <span class="trigger__text">{{fontFamily.label}}</span>
      <i class="trigger__icon triangle-icon"></i>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    sprite: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      fontFamily: {
        value: '',
        label: ''
      }
    }
  },
  computed: {
    ...mapGetters([
      'TOOL',
      'SelectScenes_Msg',
      'SelectSprites_Msg',
      'SpriteBeforeSwap',
      'downFonts'
    ]),
  },
  created () {
    this.$bus.on('font', (font, from) => {
      if(from !== 'dropdownRow') return;
      this.fontFamily.value = font.value;
      this.fontFamily.label = font.label;
      this.TOOL.updateSprite(this.sprite.id, {
        font: {
          fontFamilyUrl: font.value
        }
      }, this.sprite.scenesId, true);
      this.TOOL.updateFontList(font.value);
    });
  },
  methods: {
    async render () {
      this.fontFamily.value = this.sprite.font.fontFamilyUrl;
      this.fontFamily.label
        = ((this.downFonts.filter(v => this.fontFamily.value.replace(/"/g, '') === v.value) || [])[0] || {}).label || '';
    },
    openPopup () {
      if (this.$parent) {
        this.$parent.isShowMask = true;
      }
      let rect = this.$el.getBoundingClientRect();
      this.$bus.emit('FeaturesPop_vue',{
				name : 'fontFamily',
				posx : rect.left - 183,
				posy : rect.top,
        type : 1,
        sprite: this.sprite,
        source: this.$parent,
        from: 'dropdownRow'
			});
    }
  }
}
</script>

<style lang="scss" scoped>
  .trigger {
    display: flex;
    justify-content:space-between;
    align-items: center;
    width: 140px;
    height: 34px;
    border: solid 1px #d9ddea;
    padding-left: 12px;
    padding-right: 12px;
  }

  .triangle-icon {
    display: inline-block;
    width: 10px;
    height: 6px;
    background: url('../../../../static/svg/inverted-triangle.svg') no-repeat center;
    &:hover {
      background: url('../../../../static/svg/inverted-triangle-active.svg') no-repeat center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/popupsNew/textSetting/dropdownRow.vue